module.exports = __webpack_public_path__ + "static/media/internacional-de-seguros-phone.cf9462c5.svg";